module.exports = __webpack_public_path__ + "static/media/family_12.483e25ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_12.jpg
// module id = 5844
// module chunks = 0